import React from 'react';
import FeedbackForm from './Components/FeedbackForm/FeedbackForm';
import { IS_DISONA, IS_ROCKWEST } from './common/utils/style.util';
import { RequiredKycModal } from './Components/Modals/NewRockWest/templates/KYC';
import { BlockedDepositModalRockWest } from './Components/Modals/NewRockWest/templates/BlockedDeposit';
import { BlockedWithdrawModalRockWest } from './Components/Modals/NewRockWest/templates/BlockedWithdraw';
import { BlockedBonusModalRockWest } from './Components/Modals/NewRockWest/templates/BlockedBonus';
import { SessionExpiredModal } from './Components/Modals/SessionExpired';

import { KYCRequiredModalDisona } from './Components/Modals/Disona/KYC';
import { BlockedDepositDisona } from './Components/Modals/Disona/BlockedDeposit';
import { BlockedWithdrawDisona } from './Components/Modals/Disona/BlockedWithdraw';
import { SessionExpiredModalDisona } from './Components/Modals/Disona/SessionExpired';

export const Modals = () => {
  if (IS_ROCKWEST)
    return (
      <>
        <FeedbackForm />
        <SessionExpiredModal />
        <RequiredKycModal />
        <BlockedDepositModalRockWest />
        <BlockedWithdrawModalRockWest />
        <BlockedBonusModalRockWest />
      </>
    );
  if (IS_DISONA) {
    return (
      <>
        <KYCRequiredModalDisona />
        <BlockedDepositDisona />
        <BlockedWithdrawDisona />
        <SessionExpiredModalDisona />
      </>
    );
  }
  return null;
};
